// Async entry point — required for Module Federation shared dependency negotiation.
// webpack needs to resolve shared singletons (react, react-dom) before bootstrap runs.
import('./bootstrap');
